<template>
    <div class="analytics-correctness-mode">
        <div class="analytics-correctness-mode__total"
            :class="changeClass">
            <div
                v-if="showPreloader"
                class="analytics-correctness-mode__mode-preloader"></div>
            <template v-if="!showPreloader">
                <span class="analytics-correctness-mode__total-value">
                    <span class="analytics-correctness-mode__total-value-text">%{{ filteredCorrectnessModeData.total.value }}</span>
                    <span class="analytics-correctness-mode__total-value-change">%{{ filteredCorrectnessModeData.total.change }}</span>
                </span>
                <span class="analytics-correctness-mode__total-unit">DOĞRULUK</span>
                <span class="analytics-correctness-mode__total-label">toplam</span>
            </template>

            <span class="analytics-correctness-mode__total-icon"></span>
        </div>
        <div class="analytics-correctness-mode__wr-modes">
            <div class="analytics-correctness-mode__mode analytics-correctness-mode__mode--phonemic-vowel">
                <div
                    v-if="showPreloader"
                    class="analytics-correctness-mode__mode-preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-correctness-mode__mode-value">%{{ filteredCorrectnessModeData.phonemicVowel }}</span>
                    <span class="analytics-correctness-mode__mode-unit">DOĞRULUK</span>
                    <span class="analytics-correctness-mode__mode-label">ünlü özellikleri</span>
                </template>
                <span class="analytics-correctness-mode__mode-icon"></span>
            </div>
            <div class="analytics-correctness-mode__mode analytics-correctness-mode__mode--phonemic-consonant">
                <div
                    v-if="showPreloader"
                    class="analytics-correctness-mode__mode-preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-correctness-mode__mode-value">%{{ filteredCorrectnessModeData.phonemicConsonant }}</span>
                    <span class="analytics-correctness-mode__mode-unit">DOĞRULUK</span>
                    <span class="analytics-correctness-mode__mode-label">ünsüz özellikleri</span>
                </template>
                <span class="analytics-correctness-mode__mode-icon"></span>
            </div>
            <div class="analytics-correctness-mode__mode analytics-correctness-mode__mode--phonetic-vowel">
                <div
                    v-if="showPreloader"
                    class="analytics-correctness-mode__mode-preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-correctness-mode__mode-value">%{{ filteredCorrectnessModeData.phoneticVowel }}</span>
                    <span class="analytics-correctness-mode__mode-unit">DOĞRULUK</span>
                    <span class="analytics-correctness-mode__mode-label">ünlü değişkeleri</span>
                </template>
                <span class="analytics-correctness-mode__mode-icon"></span>
            </div>
            <div class="analytics-correctness-mode__mode analytics-correctness-mode__mode--phonetic-consonant">
                <div
                    v-if="showPreloader"
                    class="analytics-correctness-mode__mode-preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-correctness-mode__mode-value">%{{ filteredCorrectnessModeData.phoneticConsonant }}</span>
                    <span class="analytics-correctness-mode__mode-unit">DOĞRULUK</span>
                    <span class="analytics-correctness-mode__mode-label">ünsüz değişkeleri</span>
                </template>
                <span class="analytics-correctness-mode__mode-icon"></span>
            </div>
            <span class="analytics-correctness-mode__connection-line analytics-correctness-mode__connection-line--phonemic-vowel"></span>
            <span class="analytics-correctness-mode__connection-line analytics-correctness-mode__connection-line--phonemic-consonant"></span>
        </div>
        
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredCorrectnessModeData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessMode.type;
                return this.$store.state.response.analyticsCorrectness.correctnessModeData[selectedFiltertagType];
            },

            changeClass(){
                if(this.showPreloader){return '';}
                return this.filteredCorrectnessModeData.total.change > 0 ? '' : 'analytics-correctness-mode__total--change-negative';
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsCorrectnessMode)
                .then(response => response.json())
                .then(correctnessModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'correctnessModeData',
                        data: correctnessModeData,
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsCorrectnessCorrectnessMode, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(correctnessModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'correctnessModeData',
                        data: correctnessModeData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                })
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-correctness-mode.css"></style>